// extracted by mini-css-extract-plugin
module.exports = {"header":"Subscribe2_header__QrzeZ"};